module.exports = __webpack_public_path__ + "img/sounds_gray.e0435858.png";